import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  href?: string;
  showTrust?: boolean;
  onLinkClick?: () => void;
}
export function Button({
  children,
  variant = 'primary',
  href,
  showTrust = false,
  className = '',
  onLinkClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold px-8 py-4 rounded-full transition-colors duration-300 text-center text-lg md:text-xl shadow-sm';
  const variants = {
    primary: 'bg-rust text-white hover:bg-rust-600',
    secondary: 'bg-forest text-white hover:bg-forest-700'
  };
  const content = <div className="flex flex-col items-center" data-id="element-138">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-139">
        {children}
      </motion.button>
      {showTrust && <div className="flex items-center gap-2 mt-3 text-sm text-charcoal-400 font-medium" data-id="element-140">
          <ShieldCheck className="w-4 h-4 text-forest" data-id="element-141" />
          <span data-id="element-142">Acceso instantáneo • Pago 100% seguro</span>
        </div>}
    </div>;
  if (href) {
    const isExternal = /^https?:\/\//.test(href);
    return <a href={href} onClick={onLinkClick} className="inline-block w-full sm:w-auto" {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} data-id="element-143">
        {content}
      </a>;
  }
  return content;
}